import * as yup from "yup";

import {
  ocNumberOrRelation,
  registrationNumberValidatorOrRelation,
} from "../../../../utilities/validators";

import { ComponentId } from "./enums";

export const validator = yup.object().shape({
  [ComponentId.REGISTRATION_NUMBER]: registrationNumberValidatorOrRelation,
  [ComponentId.OC_NUMBER]: ocNumberOrRelation,
});
